<template>
  <v-card>
    <v-form>
      <v-stepper v-model="e1" :light="true">
        <v-stepper-header>
          <v-stepper-step :complete="e1 > 1" step="1">{{
            $t("label_Copy_from_template")
          }}</v-stepper-step>
          <v-divider></v-divider>

          <v-stepper-step :complete="e1 > 2" step="2">{{
            $t("label_Customer_data")
          }}</v-stepper-step>

          <v-divider></v-divider>

          <v-stepper-step :complete="e1 > 3" step="3">{{
            $t("label_Functional_authority")
          }}</v-stepper-step>

          <v-divider></v-divider>

          <v-stepper-step step="4" :complete="e1 > 4">{{
            $t("label_Email_Whitelist")
          }}</v-stepper-step>
          <v-divider></v-divider>

          <v-stepper-step step="5">{{ $t("label_language") }}</v-stepper-step>
        </v-stepper-header>
        <v-stepper-items>
          <!-- 从现有模板复制 -->
          <v-stepper-content step="1" style="background-color: #eeeef0">
            <v-card-text
              style="background-color: #ffffff; min-height: 350px"
              class="radius"
            >
              <v-form ref="copyform">
                <v-row>
                  <v-col cols="12" sm="6">
                    <mrc_ess_autoComplete
                      :label="$t('label_client_source') + '*'"
                      clientView
                      f1="client_short_code"
                      itemValue="uuid"
                      itemText="client_name"
                      @changeStaff="cleancompany"
                      :dropDownList="dropDownList"
                      v-model="client"
                    >
                    </mrc_ess_autoComplete>
                  </v-col>
                  <v-col cols="12" sm="6">
                    <mrc_ess_autoComplete
                      :label="$t('label_company') + '*'"
                      orgView
                      @changeStaff="getclientcontainers"
                      v-model="companyuuid"
                      :prompt_name="companyName"
                    >
                    </mrc_ess_autoComplete>
                  </v-col>
                </v-row>
              </v-form>
              <!-- <v-card :style="{'background-color':Object.keys(clientcontainers).length>0?'rgba(0,0,0,0.12)':'#ffffff'}">
                <v-card-text>
                  <clientcontainers v-for="(item, index) in Object.keys(clientcontainers)"
                                    :key="index"
                                    :class="index==0?'':'mt-8'"
                                    :containerName="item"
                                    :list="clientcontainers[item]"
                                    ref="childrenClient_containers"></clientcontainers>
                </v-card-text>
              </v-card> -->
              <v-card>
                <v-card-text>
                  <!-- <div v-for="(item, index) in clientcontainers"
                       class="mt-4"
                       :key="index">
                    <div>{{item.title}}</div>
                    <div v-for="(item2, index2) in item.children"
                         :key="index2">
                      {{item2.table_name}}
                    </div>
                  </div> -->
                  <v-treeview
                    selectable
                    v-model="tableUuid"
                    item-text="table_name"
                    item-value="id"
                    selected-color="red"
                    :items="clientcontainers"
                  ></v-treeview>
                </v-card-text>
              </v-card>
            </v-card-text>
            <!-- :disabled="btndisabled" -->
            <mrc_ess_submitBtn
              @cancel="edmit"
              @success="checkClient"
              :cancelText="$t('label_cancel')"
              :successText="$t('label_The_next_step')"
            ></mrc_ess_submitBtn>
          </v-stepper-content>

          <!-- 客户资料 -->
          <v-stepper-content step="2" style="background-color: #eeeef0">
            <v-card-text style="background-color: #ffffff" class="radius pa-0">
              <adduser ref="zjadduser"></adduser>
            </v-card-text>
            <mrc_ess_submitBtn
              @cancel="e1 = 1"
              @success="getuserzl()"
              :cancelText="$t('label_The_previous_step')"
              :successText="$t('label_The_next_step')"
              :disabled="btndisabled"
            >
            </mrc_ess_submitBtn>
          </v-stepper-content>
          <!-- 功能权限 -->
          <v-stepper-content step="3" style="background-color: #eeeef0">
            <v-card-text style="background-color: #ffffff" class="radius pa-0">
              <quanxian
                ref="zjquanxian"
                v-if="e1 >= 3"
                :uuidslist="copyuuidslist"
              ></quanxian>
            </v-card-text>

            <mrc_ess_submitBtn
              @cancel="e1 = 2"
              @success="getuserqx"
              :cancelText="$t('label_The_previous_step')"
              :successText="$t('label_The_next_step')"
            ></mrc_ess_submitBtn>
          </v-stepper-content>
          <!-- 邮箱白名单 -->
          <v-stepper-content step="4" style="background-color: #eeeef0">
            <v-card-text style="background-color: #ffffff" class="radius pa-0">
              <baimingdan ref="zjbaimingdan"></baimingdan>
            </v-card-text>
            <mrc_ess_submitBtn
              @cancel="e1 = 3"
              @success="getuseryx"
              :cancelText="$t('label_The_previous_step')"
              :successText="$t('label_The_next_step')"
            ></mrc_ess_submitBtn>
          </v-stepper-content>
          <!-- 语言 -->
          <v-stepper-content step="5" style="background-color: #eeeef0">
            <v-card-text style="background-color: #ffffff" class="radius pa-0">
              <yuyan ref="reflanguage"> </yuyan>
            </v-card-text>
            <mrc_ess_submitBtn
              @cancel="e1 = 4"
              @success="submit()"
              :loading="btnloading"
              :cancelText="$t('label_The_previous_step')"
            ></mrc_ess_submitBtn>
          </v-stepper-content>
        </v-stepper-items>
      </v-stepper>
    </v-form>
  </v-card>
</template>

<style lang="scss" scoped>
.btn {
  color: rgb(255, 173, 77);
  margin: 27px 60px;
  border-radius: 20%;
}
.btn:hover {
  background-color: rgb(255, 173, 77);
  color: white;
}
.btnbgd {
  background-color: #eeeef0;
  height: 80px;
}
.cardbox {
  background-color: white;
  padding: 0 30px;
}
.contentbox {
  background-color: white;
  padding: 10px 20px;
}
</style>

<script>
import clientcontainers from "./clientdetail/modules/clientcontainers";
import adduser from "./clientdetail/modules/adduser";
import baimingdan from "./clientdetail/baimingdan";
import quanxian from "./clientdetail/quanxianpeizhi";
import yuyan from "./clientdetail/yuyan";
import {
  copyadduserclientdetail,
  copyuserclientdetail,
} from "@/service/api/clientmanage_api.js";
import {
  getclientlist,
  edmitclientdetail,
} from "@/service/api/clientmanage_api.js";
import { getBusinessList } from "@/service/api/func_module.js";
export default {
  components: {
    adduser,
    baimingdan,
    quanxian,
    yuyan,
    clientcontainers,
  },
  data() {
    return {
      tableUuid: [],
      btnloading: false,
      btndisabled: true,
      rules: [(value) => !!value || "不能为空."],
      valid: false,
      e1: 1,
      client: "",
      companyuuid: "",
      Children: {
        //容器
      },
      dropDownList: [],
      copyuuidslist: [], //用户默认选中的权限列表
      function_permission: [],
      client_languages: [],
      select1: "", //预设语言
      select2: [], //其他语言
      listitems: [], //下拉选择list
      ysdefault: {}, //预设默认选择  判断用户是否修改
      otherlanguagelist: [], //  保存用户修改前的其他语言
      mrbase_sys_function_permission: [], //copy选择权限列表
    };
  },
  computed: {
    clientSource() {
      return { prompt_name: "mrbase_sys_clients" };
    },
    clientcontainers() {
      let dd = {};
      let arr = [];
      // this.Children = { //容器
      //   "sys_function": [ //容器名称 UI上 Container Name
      //     {
      //       "table_name": "mrbase_sys_prompt",//表名
      //       "id": "mrbase_sys_prompt"
      //     },
      //     {
      //       "table_name": "mrbase_sys_products",
      //       "id": "mrbase_sys_products"
      //     },
      //     {
      //       "table_name": "mrbase_sys_modules",
      //       "id": "mrbase_sys_modules"
      //     },
      //     {
      //       "table_name": "mrbase_sys_clients",
      //       "id": "mrbase_sys_clients"
      //     },
      //     {
      //       "table_name": "mrbase_sys_client_language",
      //       "id": "mrbase_sys_client_language"
      //     }
      //   ],
      //   "org_level": [
      //     {
      //       "table_name": "mrbase_sys_staffs",
      //       "id": "mrbase_sys_staffs"
      //     },
      //     {
      //       "table_name": "mrbase_sys_role",
      //       "id": "mrbase_sys_role"
      //     },
      //     {
      //       "table_name": "mrbase_sys_org_levels",
      //       "id": "mrbase_sys_org_levels"
      //     },
      //     {
      //       "table_name": "mrbase_sys_company",
      //       "id": "mrbase_sys_company"
      //     }
      //   ],
      //   "container_name_3": "sys_function",
      //   "container_name_2": "propertie",
      //   "container_name_1": "org_level",
      //   "propertie": [
      //     {
      //       "table_name": "mrbase_sys_params_setting",
      //       "id": "mrbase_sys_params_setting"
      //     },
      //     {
      //       "table_name": "mrbase_sys_message_template",
      //       "id": "mrbase_sys_message_template"
      //     },
      //     {
      //       "table_name": "mrbase_sys_timed_task",
      //       "id": "mrbase_sys_timed_task"
      //     },
      //     {
      //       "table_name": "mrbase_sys_company_exchange_rate",
      //       "id": "mrbase_sys_company_exchange_rate"
      //     },
      //     {
      //       "table_name": "mrbase_sys_company_time_zone",
      //       "id": "mrbase_sys_company_time_zone"
      //     },
      //     {
      //       "table_name": "mrbase_sys_password_security",
      //       "id": "mrbase_sys_password_security"
      //     },
      //     {
      //       "table_name": "mrbase_sys_company_property",
      //       "id": "mrbase_sys_company_property"
      //     },
      //     {
      //       "table_name": "mrbase_sys_timed_task_log",
      //       "id": "mrbase_sys_timed_task_log"
      //     }
      //   ],
      //   "container_count": 3 //容器数量  因容器名称不确定需要用数量去遍历所有的容器， container_name 再加遍历数量的value 获取到容器的key
      // }
      let a = 1;
      for (var key in this.Children) {
        if (Array.isArray(this.Children[key])) {
          arr.push({ children: this.Children[key], table_name: key, id: a });
          a++;
        }
      }
      let as = arr.map((item) => {
        item.children.forEach((item2) => {
          item2 = { ...item2, id: item2.table_name };
        });
      });
      return arr;
    },
    companyName() {
      return {
        prompt_name: "org_level_relevance_client",
        client_uuid: this.client,
      };
    },
    listClient_containers() {
      //容器资料
      var client_containersarr = [];
      if (this.$refs.childrenClient_containers > 0) {
        this.$refs.childrenClient_containers.map((item) => {
          client_containersarr = client_containersarr.concat(
            JSON.parse(JSON.stringify(item.copylist))
          );
        });
      }
      const list = [];
      if (client_containersarr.length > 0) {
        client_containersarr.map((item) => {
          if (item.checked == true) {
            delete item.checked;
            list.push(item);
          }
        });
      }
      return list;
    },
    xzuserlist() {
      //新增用户资料
      if (!this.$refs.zjadduser.userdetail.client_address_province_id) {
        delete this.$refs.zjadduser.userdetail.client_address_province_id;
      }
      if (!this.$refs.zjadduser.userdetail.client_address_city_id) {
        delete this.$refs.zjadduser.userdetail.client_address_city_id;
      }
      // console.log('未选择城市', this.$refs.zjadduser.userdetail);
      return this.$refs.zjadduser.userdetail;
    },
    // mrbase_sys_function_permission () {     //客户功能角色权限子表
    //   console.log(this.$refs.zjquanxian.getchangeref());
    //   return this.$refs.zjquanxian.getchangeref()
    // },
    mrbase_sys_client_contacts() {
      //客户联系人信息表
      return this.$refs.zjadduser.desserts; //数组
    },
    // mrbase_sys_client_email_whitelist
    mrbase_sys_client_email_whitelist() {
      const baimingdan = []; //客户邮箱白名单子表
      this.$refs.zjbaimingdan.states.forEach((item) => {
        const obj = {
          "~table~": "mrbase_sys_client_email_whitelist",
          whitelist_domain: item,
        };
        baimingdan.push(obj);
      }); //数组
      return baimingdan;
    },
  },
  async mounted() {
    getclientlist({
      //获取客户列表信息
      cpage: 1,
      pagesize: 2147483647,
    }).then((res) => {
      if (res.code == 200) {
        this.dropDownList = res.data;
      }
    });
    const res = await getBusinessList("client_language");
    // console.log(res.data);
    if (res.data.length > 0) {
      res.data.map((item) => {
        //下拉列表
        this.listitems.push(item.view_fields);
      });
    }
  },
  methods: {
    cleancompany() {
      this.companyuuid = "";
      this.Children = {};
      this.copyuuidslist = []; //用户默认选中权限列表
      this.function_permission = []; ////功能权限列表
    },
    changee1(v) {
      this.e1 = v;
    },
    async getclientcontainers() {
      //后台容器数据     //copy_client_uuid 变为client_uuid  copy_org_level_uuid:org_level_uuid
      const res = await copyuserclientdetail({
        client_uuid: this.client,
        org_level_uuid: this.companyuuid,
      });
      if (res.code == 200) {
        this.Children = res.data.client_containers;
        this.copyuuidslist = res.data.mrbase_sys_function_permission; //用户默认选中权限列表
        this.function_permission = res.data.function_permission_tree; ////功能权限列表
        this.btndisabled = false;
        // this.client_languages = res.data.client_languages
        // console.log(this.client_languages);
        //生成语言列表
        // this.getlanguage(this.client_languages)
      }
    },
    // saveClientcontainers () {  //获取容器数据
    //   // console.log(this.listClient_containers)
    // },
    checkClient() {
      console.log(this.tableUuid);
      if (this.tableUuid.length > 0) this.e1 = 2;
      // this.e1 = 2
    },
    getuserzl() {
      //客户资料获取
      // this.e1 = 3
      if (this.$refs.zjadduser.formverify()) {
        //表单验证
        this.e1 = 3;
      } else {
        this.$myConfirm({
          content: this.$t(
            "message_The_information_was_not_entered_completely"
          ),
        })
          .then(() => {})
          .catch(() => {});
      }
    },
    // 获取权限数据
    getuserqx(val) {
      // if (!this.$refs.zjquanxian.getchangeref().length > 0) {
      //   this.$myConfirm({
      //     content: this.$t(
      //       'message_permission_list_must_select_at_least_one_item'
      //     ),
      //   })
      // } else {
      //   this.e1 = 4
      //   this.mrbase_sys_function_permission = this.$refs.zjquanxian.getchangeref()
      // }
      const obj = this.$refs.zjquanxian.success();
      if (obj.NoButton) {
        this.$Message({
          text: this.$t("message_Permissions_cannot_be_empty"),
          color: "rgba(0,0,0,0.78)",
        });
      } else {
        this.mrbase_sys_function_permission = this.$clone(
          obj.button_uuid_arr
        ).map((item) => {
          return {
            function_uuid: item.uuid1,
            button_uuid: item.uuid,
          };
        });
        this.e1 = 4;
      }
    },
    // 获取邮箱白名单
    getuseryx() {
      if (this.$refs.zjbaimingdan.isemail != "") {
        this.$myConfirm({
          content: this.$t("verify_The_mailbox_format_is_wrong"),
        });
      } else {
        this.e1 = 5;
      }
    },
    getlanguage(val) {
      if (val.length > 0) {
        val.map((item, index) => {
          //获取数据
          if (item.is_default_language == 1) {
            //应该等于1
            this.select1 = val[index].client_language_code; //数据要处理
            this.ysdefault = val[index];
          } else {
            this.select2.push(val[index]);
            this.otherlanguagelist.push(val[index]);
          }
        });
      }
    },
    changeis(item) {
      // item.is_default_language = 1
    },
    changeno(item) {
      // item.is_default_language = 0
    },
    // 取消
    edmit() {
      this.$myConfirm({
        content: this.$t("message_Confirm_the_cancellation_of_the_edit"),
      })
        .then((res) => {
          this.$router.push({
            name: "clientmanage",
          });
        })
        .catch((err) => {});
    },
    // 总提交 添加新的用户
    async submit() {
      if (this.$refs.reflanguage.mrbase_sys_client_language.length) {
        let file1 = this.$refs.zjadduser.light_mode_icon_file;
        let file2 = this.$refs.zjadduser.dark_mode_icon_file;
        this.xzuserlist.mrbase_sys_function_permission =
          this.mrbase_sys_function_permission;
        this.xzuserlist.mrbase_sys_client_contacts =
          this.mrbase_sys_client_contacts || [];
        this.xzuserlist.mrbase_sys_client_email_whitelist =
          this.mrbase_sys_client_email_whitelist || [];
        this.xzuserlist.mrbase_sys_client_language =
          this.$refs.reflanguage.mrbase_sys_client_language;
        this.xzuserlist.client_containers =
          this.tableUuid.map((item) => {
            return { table_name: item };
          }) || [];
        this.xzuserlist.copy_client_uuid = this.client;
        this.xzuserlist.copy_org_level_uuid = this.companyuuid;
        this.btnloading = true;
        await copyadduserclientdetail(this.xzuserlist).then(async (res) => {
          if (res.code == 200) {
            //上传文件
            let p1 = this.$uploadFiles(file1, {
              module_uuid:'client',
              function_uuid: this.$store.state.menuFunctionUuid,
              attachment_data_table: "mrbase_sys_clients",
              attachment_data_field: "light_mode_icon",
              org_level_uuid: this.$store.state.currentCompany,
              uuid: res.data.uuid,
            });
            let p2 = this.$uploadFiles(file2, {
              module_uuid:'client',
              function_uuid: this.$store.state.menuFunctionUuid,
              attachment_data_table: "mrbase_sys_clients",
              attachment_data_field: "dark_mode_icon",
              org_level_uuid: this.$store.state.currentCompany,
              uuid: res.data.uuid,
            });
            await Promise.all([p1, p2]);
            this.$Message({
              text: this.$t("message_The_operation_was_successful"),
            });
            this.$router.push({
              name: "clientmanage",
            });
          }
        });
        this.btnloading = false;
      } else {
        this.$myConfirm({
          content: this.$t("message_default_language_must_be_selected"),
        });
      }
    },
  },
  watch: {},
};
</script>
<style scoped>
.v-stepper {
  box-shadow: none;
}
.v-stepper__header {
  background-color: #eeeef0;
  box-shadow: none;
}
.v-stepper__content {
  padding: 0px 0px;
}
.radius {
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
}
</style>
